export default "__VITE_ASSET__CH35V9MA__"